"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftDemands = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../../../constants");
const elements_1 = require("../../../../elements");
const by_filter_1 = require("../by-filter");
const Cell_1 = require("../components/Cell");
const Row_1 = require("../components/Row");
const VacanciesTitle_1 = require("../components/VacanciesTitle");
const useSchedule_1 = require("../useSchedule");
const Wrapper = styled_1.default.div({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    margin: 'auto',
    fontWeight: 500,
    color: constants_1.Color.CHARCOAL,
});
const getColor = (booked, min, max) => {
    if (booked > max) {
        return constants_1.Color.LIGHT_YELLOW;
    }
    if (booked >= min) {
        return constants_1.Color.LIGHT_GREEN;
    }
    return constants_1.Color.LIGHT_RED;
};
const ShiftDemands = (props) => {
    const { startDate, days, shifts: allShifts, isScrolled, zoom } = (0, useSchedule_1.useSchedule)();
    const shifts = allShifts.filter((0, by_filter_1.byCellFilter)(props));
    return ((0, jsx_runtime_1.jsxs)(Row_1.Row, { children: [(0, jsx_runtime_1.jsx)(Cell_1.Cell, { isTitle: true, rowSpan: 1, rightShadow: isScrolled, children: (0, jsx_runtime_1.jsx)(VacanciesTitle_1.VacanciesTitle, { ...props, shiftHours: props.shiftHours, startDate: startDate, persisted: false, shiftIds: [] }) }), days.map((day) => {
                const shiftsOnDay = shifts.filter((shift) => shift.date === day.dateISO);
                const shiftsFilled = shiftsOnDay.filter((s) => s.bookedCandidateId || typeof s.rowKey === 'number').length;
                const { min, max } = props.demands.find((d) => d.date === day.dateISO) || { min: 0, max: 0 };
                return ((0, jsx_runtime_1.jsx)(Cell_1.Cell, { disabled: !day.withinRange, weekend: day.isWeekend, backgroundColor: getColor(shiftsFilled, min, max), children: (0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(elements_1.Text, { fontWeight: 600, children: shiftsFilled }), zoom !== 'month' && ((0, jsx_runtime_1.jsx)(elements_1.Text, { fontWeight: 400, children: (0, jsx_runtime_1.jsxs)("em", { children: ["(", min === max ? min : `${min} - ${max}`, ")"] }) }))] }) }, day.dateISO));
            })] }));
};
exports.ShiftDemands = ShiftDemands;
